import { render, staticRenderFns } from "./coinsDetail.vue?vue&type=template&id=4a4c316c&scoped=true&"
import script from "./coinsDetail.vue?vue&type=script&lang=js&"
export * from "./coinsDetail.vue?vue&type=script&lang=js&"
import style0 from "./coinsDetail.vue?vue&type=style&index=0&id=4a4c316c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4c316c",
  null
  
)

export default component.exports